import React from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import DataTable from "react-data-table-component";
import "./Listing.css";
import { residentColumnsearch } from "./residentColumsearch";

const customStyle = {
	table:{
		style: {
			border:'1px solid #DEDEDE', 
			borderRadius:'5px'
		}
	},
	header: {
		style:{
			color: '#193062'
		}
	},
	headRow: {
		style: {
			border:"none",
			backgroundColor: '#CDD4DC',
			fontWeight: 'bold',
            color:'#002d82',
            fontSize:'14px',
            whiteSpace:'unset'
		}
	},
	rows: {
		stripedStyle: {
			backgroundColor: '#F2F3F5'
		}
	}
}



function ResidentStatusListingsearch( props ) {
    
	const handleRowClick = (row) => {
					props.getData(row)
					props.plzclose()
					props.ssnfunc("*****************")
					
	}
    
    return (
		<div style={{   borderTop:'none'}}>
		{props.loading && <>
			<Backdrop
			sx={{ color: 'white', zIndex: (theme) => theme.zIndex.drawer + 1 }}
			open={props.loading}
		>
<CircularProgress sx={{color:'white'}} /><span >  &nbsp;&nbsp;&nbsp;&nbsp; Loading Data... </span>
</Backdrop>
	
	</>}
			<DataTable
				title=""
				columns={residentColumnsearch}
				data={props.records}
				pagination
				striped
				highlightOnHover
				onRowClicked={handleRowClick}
				customStyles={customStyle}
				keyField='rowKey'
				paginationRowsPerPageOptions={[5,10,15,20]}				
				paginationResetDefaultPage={props.resetPagination}
				paginationPerPage={5}
				paginationComponentOptions={{
					rowsPerPageText:'Records per page',
					rangeSeparatorText:'Out of'
				}}
			/>
            
		</div>
    ) ;
}

export default ResidentStatusListingsearch;
